import axios from "axios";

const API = axios.create({
  baseURL: "https://mtlchrislee-blog.herokuapp.com/",
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("profile")).token
    }`;
  }

  return req;
});

export const createSubject = (newSubject) => API.post("/subjects", newSubject);
export const getSubjects = () => API.get("/subjects");
export const getCourses = (subjectName) =>
  API.get(`/subjects/${subjectName}/courses`);
export const getCourse = (subjectName, id) =>
  API.get(`/subjects/${subjectName}/course/${id}`);

export const createCourse = (newCourse) => API.post("/course", newCourse);
export const editCourse = (id, editedCourse) =>
  API.put(`/course/${id}`, editedCourse);
export const getComments = (id) => API.get(`/course/${id}/comments`);
export const createComment = (id, comment) =>
  API.post(`/course/${id}/comment`, comment);

export const deleteComment = (id) => API.delete(`/comment/${id}/`);

export const signIn = (formData) => API.post("/user/signin", formData);
export const signUp = (formData) => API.post("/user/signup", formData);
